/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contact } from '../../models/contact';

export interface GetLabContacts$Params {
  bpGuid: string;
  customerAccountId: number;
  contactId?: number;
  shipToAddressId?: number;
}

export function getLabContacts(http: HttpClient, rootUrl: string, params: GetLabContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Contact>>> {
  const rb = new RequestBuilder(rootUrl, getLabContacts.PATH, 'get');
  if (params) {
    rb.query('bpGuid', params.bpGuid, {});
    rb.query('customerAccountId', params.customerAccountId, {});
    rb.query('contactId', params.contactId, {});
    rb.query('shipToAddressId', params.shipToAddressId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Contact>>;
    })
  );
}

getLabContacts.PATH = '/sample/instruction/contact/list';
